module.exports = __webpack_public_path__ + "img/login-side-image.05b2415f.svg";